module.exports = __webpack_public_path__ + "static/media/help_outline-24px.4f0cfc2a.svg";